<template>
  <div class="item" v-bind:class="{ 'show-outline': cardsSetting.text !== 'outside' }" :style="itemStyles"
  @click="onClick()" @mouseover="mouseOver()" @mouseleave="mouseLeave()">

  <a :href="seoLink" @click.prevent="preventLink">
   <!-- settings -->
    <div v-if="item.icon" :style="imgStyles">
      <div class="icon">
        <icon :name="item.icon" scale="7"></icon>
      </div>
    </div>

    <!-- card image -->
     <div v-else ref="image" class="image" :style="imgStyles">
      <div :id="'data-float-'+item.id" class="data-float">
        <div class="data-float-text">
          <!-- play -->
          <span v-if="cardsSetting.play && (type === 'card-contents'|| type === 'content-category' || type === 'content-detail')"><icon name="regular/play-circle" class="icon-shadow"></icon></span>
          <!-- text inside -->
          <span v-if="cardsSetting.text === 'inside'" class="name">{{item.name}}</span>
        </div>
      </div>

      <!-- favorite -->
      <span :id="'favorite-icon-' + item.id" :class="'favorite-icon favorite-' + cardsSetting.favorite" v-on:click.stop="toFavorites(item)">
        <div v-if="showToFavorites">
          <icon v-if="waiting === item.id" name="spinner" spin class="icon-shadow"></icon>
          <icon v-else-if="!item.is_favorite" name="regular/heart" class="icon-shadow"></icon>
          <icon v-else name="heart" class="icon-shadow"></icon>
        </div>
      </span>

      <!-- video trailer -->
      <div v-if="cardsSetting.trailer" :id="'video-list-preview-'+item.id"  class="video-list-preview"></div>

      <!-- price -->
      <div v-if="type === 'card-products'" class="card-product-price">
        <span>{{item.price | currency}}</span>
      </div>

      <!-- settings -->
      <div class="card-description">
        <span style="-webkit-box-orient: vertical;">{{item.description}}</span>
      </div>
    </div>

    <!-- text outside -->
    <div v-if="cardsSetting.text === 'outside' || type === 'card-settings'" class="text" :class="{ 'marquee': this.$store.getters.getData.template1 !== 'SUR'}"><span>{{item.name}}</span></div>
    </a>
  </div>
</template>

<script>
import Bus from '@/components/ControlBus'
import videojs from 'video.js'
// require('videojs-contrib-hls')
const contentsService = require('@/services/contents.js')

export default {
  name: 'ListItem',
  props: ['wrapper', 'item', 'size', 'type', 'typeCat', 'route', 'backReplace'],
  data () {
    return {
      active: false,
      waiting: false,
      cardsSetting: { // default
        text: 'outside', // outside, inside or ''
        play: false, // true or false
        trailer: false, // true or false
        favorite: 'top' // top or bottom
      }
    }
  },
  created: function () {
    // CONTENTS
    if (this.$route.name === 'content' || this.$route.name === 'search') {
      // Plantilla pantalla principal de contenidos (root-categories)
      if (this.$store.getters.getData.template1 === 'DFL') {
        this.cardsSetting = { text: 'outside', play: false, trailer: false, favorite: 'top' }
      } else if (this.$store.getters.getData.template1 === 'PIN' || this.$store.getters.getData.template1 === 'IMG') {
        this.cardsSetting = { text: '', play: false, trailer: true, favorite: 'bottom' }
      } else if (this.$store.getters.getData.template1 === 'PLY') {
        this.cardsSetting = { text: 'inside', play: true, trailer: true, favorite: 'top' }
      } else if (this.$store.getters.getData.template1 === 'PLN') {
        this.cardsSetting = { text: 'inside', play: true, trailer: false, favorite: 'top' }
      }
    } else if (this.$route.name === 'content-category') {
      // Plantilla pantalla anidada de contenidos (sub-category)
      if (this.$store.getters.getData.template2 === 'DFL') {
        this.cardsSetting = { text: 'outside', play: false, trailer: false, favorite: 'top' }
      } else if (this.$store.getters.getData.template2 === 'PIN' || this.$store.getters.getData.template1 === 'IMG') {
        this.cardsSetting = { text: '', play: false, trailer: false, favorite: 'bottom' }
      } else if (this.$store.getters.getData.template2 === 'PLY') {
        this.cardsSetting = { text: 'inside', play: true, trailer: true, favorite: 'top' }
      } else if (this.$store.getters.getData.template2 === 'PLN') {
        this.cardsSetting = { text: 'inside', play: true, trailer: false, favorite: 'top' }
      }
    } else if (this.$route.name === 'content-detail' || this.$route.name === 'search-content-detail') {
      // Plantilla pantalla precontenido de contenidos (content-preview)
      if (this.$store.getters.getData.template5 === 'DFL') {
        this.cardsSetting = { text: 'outside', play: false, trailer: false, favorite: 'top' }
      } else if (this.$store.getters.getData.template5 === 'PIN' || this.$store.getters.getData.template1 === 'IMG') {
        this.cardsSetting = { text: '', play: false, trailer: true, favorite: 'bottom' }
      } else if (this.$store.getters.getData.template5 === 'PLY') {
        this.cardsSetting = { text: 'inside', play: true, trailer: true, favorite: 'top' }
      } else if (this.$store.getters.getData.template5 === 'PLN') {
        this.cardsSetting = { text: 'inside', play: true, trailer: false, favorite: 'top' }
      }
    }
    // PRODUCTS
    if (this.$route.name === 'shop') {
      // Plantilla pantalla principal de productos (root-contents)
      if (this.$store.getters.getData.template3 === 'DFL') {
        this.cardsSetting = { text: 'outside', play: false, trailer: false, favorite: 'top' }
      } else if (this.$store.getters.getData.template3 === 'PIN' || this.$store.getters.getData.template1 === 'IMG') {
        this.cardsSetting = { text: '', play: false, trailer: false, favorite: 'bottom' }
      } else if (this.$store.getters.getData.template3 === 'PLN') {
        this.cardsSetting = { text: 'inside', play: true, trailer: false, favorite: 'top' }
      }
    } else if (this.$route.name === 'shop-category') {
      // Plantilla pantalla anidada de productos (sub-category)
      if (this.$store.getters.getData.template4 === 'DFL') {
        this.cardsSetting = { text: 'outside', play: false, trailer: false, favorite: 'top' }
      } else if (this.$store.getters.getData.template4 === 'PIN' || this.$store.getters.getData.template1 === 'IMG') {
        this.cardsSetting = { text: '', play: false, trailer: false, favorite: 'bottom' }
      } else if (this.$store.getters.getData.template3 === 'PLN') {
        this.cardsSetting = { text: 'inside', play: true, trailer: false, favorite: 'top' }
      }
    } else if (this.$route.name === 'content-detail') {
      // Plantilla pantalla precontenido de productos (product)
      // if (this.$store.getters.getData.template6 === 'DFL') {
      //   this.cardsSetting = { text: 'outside', play: false, trailer: false, favorite: 'top' }
      // } else if (this.$store.getters.getData.template6 === 'PIN') {
      //   this.cardsSetting = { text: '', play: false, trailer: false, favorite: 'bottom' }
      // }
    }
  },
  mounted: function () {
    if (this.type !== 'card-settings') {
      // si no hacemos lazyload se demora mucho la carga de imágenes
      // con scroll no cargan imagenes en samsung????
      window.addEventListener('scroll', this.lazyLoad)
      window.addEventListener('resize', this.lazyLoad)
      window.addEventListener('orientationchange', this.lazyLoad)
      this.lazyLoad()

      // this.loadImage()
    }
  },
  methods: {
    onClick: function () {
      // paramos trailer
      this.mouseLeave()

      // guardamos item en store
      if (this.type === 'card-contents') { this.$store.commit('contentStackPush', this.item) }

      // cambiamos route
      let route = ''
      this.item.route ? route = this.item.route : route = this.route

      if (this.$store.getters.platform === 'browser' && this.item.openExternalURL) {
        window.location.href = this.item.openExternalURL
      } else {
        if (this.item.singleRoute) {
          this.$router.push({name: route})
        } else {
          if (this.backReplace) {
            this.$router.replace({name: route, params: {id: this.item.id}})
          } else {
            this.$router.push({name: route, params: {id: this.item.id}})
          }
        }
      }
    },
    mouseOver: function () {
      if (this.cardsSetting.trailer && this.$store.getters.platform === 'browser') {
        clearTimeout(this.timeout)
        if (this.item.trailer) {
          let elem = this.$el.querySelector('#video-list-preview-' + this.item.id)
          elem.classList.add('loading-preview')

          if (this.$store.getters.getData.bucket_type === 'ODM') {
          // trailer ODM
            contentsService.getTrailer({'url': this.item.trailer}).then(response => {
              this.timeout = setTimeout(() => {
                if (elem.innerHTML === '' && elem.classList.contains('loading-preview')) {
                  elem.innerHTML = `
                    <video id="video-card-preview-${this.item.id}" class="video-js vjs-no-icons fadein" style="object-fit:cover;width:100%;height:100%;" loop autoplay ${this.muted}>
                      <source src="` + response.data.url + `" type="application/x-mpegURL">
                    </video>`

                  this.$emit('trailerPlay')
                  this.$el.querySelector('#data-float-' + this.item.id).classList.add('fadeout')
                  this.$el.querySelector('#favorite-icon-' + this.item.id).classList.add('fadeout')

                  // player videojs
                  this.player = videojs('video-card-preview-' + this.item.id); this.player.play()
                }
              }, 1000)
            })
          } else {
            // trailer normal
            this.timeout = setTimeout(() => {
              if (elem.innerHTML === '' && elem.classList.contains('loading-preview')) {
                elem.innerHTML = `
                  <video class="fadein" style="object-fit:cover;width:100%;height:100%;" autoplay ${this.muted}>
                    <source src="` + this.item.trailer + `" type="video/mp4">
                  </video>`
                this.$emit('trailerPlay')
                this.$el.querySelector('#data-float-' + this.item.id).classList.add('fadeout')
                this.$el.querySelector('#favorite-icon-' + this.item.id).classList.add('fadeout')
              }
            }, 1000)
          }
        }
      }
    },
    mouseLeave: function (item) {
      if (this.cardsSetting.trailer && this.$store.getters.platform === 'browser') {
        clearTimeout(this.timeout)
        if (this.item.trailer) {
          let elem = this.$el.querySelector('#video-list-preview-' + this.item.id)
          elem.classList.remove('loading-preview')

          if (elem && elem.innerHTML !== '') {
            elem.innerHTML = ''
            this.$el.querySelector('#data-float-' + this.item.id).classList.remove('fadeout')
            this.$el.querySelector('#favorite-icon-' + this.item.id).classList.remove('fadeout')

            if (this.$store.getters.getData.bucket_type === 'ODM') {
              if (this.player) this.player.dispose()
            }

            this.$emit('trailerStop')
          }
        }
      }
    },
    lazyLoad: function () {
      if (this.active === false) {
        this.active = true

        setTimeout(() => {
          if ((this.$el.getBoundingClientRect().top <= (window.innerHeight + 200) && this.$el.getBoundingClientRect().bottom >= 0)) {
            window.removeEventListener('scroll', this.lazyLoad)
            this.loadImage()
          }
          this.active = false
        }, 200)
      }
    },
    loadImage: function () {
      let srcImg
      if (this.type === 'content-detail' || this.type === 'search-card-contents' || this.type === 'search-content-detail' || this.typeCat === 'FAV' || this.typeCat === 'LAS' || this.typeCat === 'NEW' || this.typeCat === 'MOS') {
        srcImg = this.item.alternative_image_medium ? this.item.alternative_image_medium : this.item.alternative_image
      }

      if (!srcImg) {
        srcImg = this.item.image_medium ? this.item.image_medium : this.item.image
      }

      let bgImage = new Image()
      bgImage.onload = () => {
        if (this.$refs.image) {
          this.$el.style.backgroundColor = 'transparent'
          this.$refs.image.style.backgroundImage = 'url("' + srcImg + '")'
          this.$refs.image.style.opacity = 1
        }
      }
      bgImage.src = srcImg
    },
    toFavorites: function (item) {
      if (!this.waiting) {
        this.waiting = item.id
        if (!this.item.is_favorite) {
          contentsService.addFavorites({content: this.item.id}).then(response => {
            this.item.is_favorite = response.data.id
            this.waiting = false
            Bus.$emit('update-list', { item: this.item, action: 'add-favorite', idFav: this.item.is_favorite })
            Bus.$emit('update-content-main', { item: this.item, action: 'add-favorite', idFav: this.item.is_favorite })
          }).catch(() => {
            this.waiting = false
          })
        } else {
          contentsService.deleteFavorites(this.item.is_favorite).then(response => {
            this.item.is_favorite = 0
            this.waiting = false
            Bus.$emit('update-list', { item: this.item, action: 'remove-favorite' })
            Bus.$emit('update-content-main', { item: this.item, action: 'remove-favorite' })
          }).catch(() => {
            this.waiting = false
          })
        }
      }
    },
    preventLink: function (event) {
      event.preventDefault()
    }
  },
  computed: {
    itemStyles: function () {
      return {
        width: this.size.width + 'px'
      }
    },
    imgStyles: function () {
      return {
        width: this.size.width + 'px',
        height: this.size.height + 'px'
      }
    },
    showToFavorites: function () {
      return this.$store.getters.getData.is_favorite && this.$store.getters.user && this.type === 'card-contents' && this.typeCat !== 'FAV' && this.typeCat !== 'LAS'
    },
    muted: function () {
      return (this.$store.getters.muted && this.$store.getters.platform === 'browser') ? 'muted' : ''
    },
    seoLink: function () {
      let route = ''
      this.item.route ? route = this.item.route : route = this.route

      if (route === 'content-category' || route === 'content-detail') {
        return '/#/content/' + route + '/' + this.item.id
      } else if (route === 'shop-category' || route === 'shop-product') {
        route = route.replace('shop-', '')
        return '/#/shop/' + route + '/' + this.item.id
      } else {
        return '/#'
      }
    }
  },
  beforeDestroy: function () {
    if (this.type !== 'card-settings') {
      window.removeEventListener('scroll', this.lazyLoad)
      window.removeEventListener('resize', this.lazyLoad)
    }
  }
}
</script>

<style lang="sass" scoped>
.item.show-outline
  outline: .3rem solid transparent

// evita que se dispare mouseOver/mouseLeave con elementos hijos
.item *
  pointer-events: none

.item
  position: relative
  float: left
  // width: 24vw
  // background: #ffffff
  // background-color: rgba(255, 255, 255, 0.85)
  // background-position: center center
  // background-repeat: no-repeat
  // background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDQ4IDQ4IiBoZWlnaHQ9IjQ4cHgiIGlkPSJMYXllcl8xIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCA0OCA0OCIgd2lkdGg9IjQ4cHgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxwYXRoIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQzLDQxSDVjLTIuMjA5LDAtNC0xLjc5MS00LTRWMTFjMC0yLjIwOSwxLjc5MS00LDQtNGgzOGMyLjIwOSwwLDQsMS43OTEsNCw0djI2ICBDNDcsMzkuMjA5LDQ1LjIwOSw0MSw0Myw0MXogTTQ1LDExYzAtMS4xMDQtMC44OTYtMi0yLTJINWMtMS4xMDQsMC0yLDAuODk2LTIsMnYyNmMwLDEuMTA0LDAuODk2LDIsMiwyaDM4YzEuMTA0LDAsMi0wLjg5NiwyLTJWMTF6ICAgTTQxLjMzNCwzNC43MTVMMzUsMjguMzgxTDMxLjM4MSwzMmwzLjMzNCwzLjMzNGMwLjM4MSwwLjM4MSwwLjM4MSwwLjk5OSwwLDEuMzgxYy0wLjM4MiwwLjM4MS0xLDAuMzgxLTEuMzgxLDBMMTksMjIuMzgxICBMNi42NjYsMzQuNzE1Yy0wLjM4MSwwLjM4MS0wLjk5OSwwLjM4MS0xLjM4MSwwYy0wLjM4MS0wLjM4Mi0wLjM4MS0xLDAtMS4zODFMMTguMTksMjAuNDI5YzAuMDMyLTAuMDQ4LDAuMDUzLTAuMTAxLDAuMDk1LTAuMTQ0ICBjMC4xOTctMC4xOTcsMC40NTctMC4yODcsMC43MTUtMC4yODFjMC4yNTgtMC4wMDYsMC41MTgsMC4wODQsMC43MTUsMC4yODFjMC4wNDIsMC4wNDMsMC4wNjIsMC4wOTYsMC4wOTUsMC4xNDRMMzAsMzAuNjE5ICBsNC4xOS00LjE5YzAuMDMzLTAuMDQ3LDAuMDUzLTAuMTAxLDAuMDk1LTAuMTQ0YzAuMTk3LTAuMTk2LDAuNDU3LTAuMjg3LDAuNzE1LTAuMjgxYzAuMjU4LTAuMDA2LDAuNTE4LDAuMDg1LDAuNzE1LDAuMjgxICBjMC4wNDIsMC4wNDMsMC4wNjIsMC4wOTcsMC4wOTUsMC4xNDRsNi45MDUsNi45MDVjMC4zODEsMC4zODEsMC4zODEsMC45OTksMCwxLjM4MUM0Mi4zMzMsMzUuMDk2LDQxLjcxNSwzNS4wOTYsNDEuMzM0LDM0LjcxNXogICBNMjksMTljLTIuMjA5LDAtNC0xLjc5MS00LTRzMS43OTEtNCw0LTRzNCwxLjc5MSw0LDRTMzEuMjA5LDE5LDI5LDE5eiBNMjksMTNjLTEuMTA0LDAtMiwwLjg5Ni0yLDJzMC44OTYsMiwyLDJzMi0wLjg5NiwyLTIgIFMzMC4xMDQsMTMsMjksMTN6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=')
  // background-size: contain
  // transition: transform .3s
  border-radius: .2rem .2rem .2rem .2rem
  cursor: pointer
  // margin-right: 1vw
  margin-top: .2rem
  margin-right: .2rem // override styles
  margin-bottom: .2rem // override styles
  margin-left: .2rem

  .image
    position: relative
    background-position: center center
    background-repeat: no-repeat
    background-size: cover
    border-radius: .2rem .2rem 0 0
    opacity: 0
    transition: opacity .2s linear

  .text
    position: relative
    font-size: 1.3rem
    color: #373a3c
    background: #ffffff
    // padding-top: .3rem
    // padding-bottom: .3rem
    padding-left: 1rem
    padding-right: 1rem
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
    border-radius:  0 0 .2rem .2rem

  .icon
    color: #373a3c
    font-size: 1.3rem
    position: absolute
    top: 0
    width: 100%
    height: 100%
    padding-top: 1rem
    display: flex
    display: -webkit-flex
    flex-direction: column
    justify-content: center
    -webkit-justify-content: center
    align-items: center
    -webkit-align-items: center
    text-align: center
    background: #DCD6D6

// favorite icon
.favorite-icon
  position: absolute
  top: 0
  right: 0
  margin: 0.6rem
  color: white
  z-index: 9

.icon-shadow
  font-size: 2.5rem
  filter: drop-shadow(0 0 0.1rem black)

.favorite-icon.favorite-bottom
  top: auto!important
  bottom: 0!important

// data trailer
.data-float
  position: absolute
  top: 0
  left: 0
  height: 100%
  width: 100%
  overflow: hidden
  color: #fff
  z-index: 6
  // background-image: linear-gradient(to top, rgba(0, 0, 0, .9), rgba(0, 0, 0, 0))

  .data-float-text
    position: absolute
    bottom: 0
    left: 0
    width: 100%
    padding: 5px 8px 5px 8px

    span
      float: left
      width: 100%
      text-shadow: #000000 0.1em 0.1em 0.2em
      color: inherit
      font-size: 3rem

    .name
      font-size: 1.1rem
      font-weight: bold

      // overflow ellipsis una líneas
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis

    // span:nth-child(3)
    //   font-family: 'Roboto Light', sans-serif;
    //   font-size: .9rem
    //   margin-bottom: 5px;
    //   line-height: 1.1

      // overflow ellipsis dos líneas
      // overflow: hidden
      // text-overflow: ellipsis
      // display: -webkit-box
      // // line-height: 16px;     // fallback */
      // // max-height: 32px;      // fallback */
      // line-height: 1.1em
      // height: 2em       // height is 2x line-height, so two lines will display
      // -webkit-line-clamp: 2 // number of lines to show */
      // -webkit-box-orient: vertical

.data-float.fadeout .data-float-text, .favorite-icon.fadeout
  transition: opacity .1s linear
  transition-delay: 5s
  opacity: 0

.item:hover .data-float
  // background-color: rgba(0, 0, 0, 0);
  transition: opacity .1s linear
  transition-delay: .3s
  opacity: 1

.video-list-preview
  position: absolute
  top: 0
  left: 0
  height: 100%
  width: 100%
  overflow: hidden
  z-index: 5

// shop
.card-product-price
  position: absolute
  top: 0
  left: 0
  height: 100%
  width: 100%
  opacity: 0
  font-size: 2.6rem
  font-weight: bold
  z-index: 10

  display: flex
  display: -webkit-flex
  flex-direction: column
  justify-content: center
  -webkit-justify-content: center
  align-items: center
  -webkit-align-items: center

.card-product-price:hover
  background-color: rgba(white, 0.5)
  transition: opacity .2s linear
  opacity: 1!important
  z-index: 50!important

.container-list:focus .item.active .card-product-price
  background-color: rgba(white, 0.5)
  // transition: opacity .2s linear;
  opacity: 1!important;

.card-description
  position: absolute
  top: 0
  left: 0
  height: 100%
  width: 100%
  padding: 1rem
  font-size: 1.1rem
  color: #fff
  background-color: rgba(0,0,0,.8);

  opacity: 0
  display: none!important

  span
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;

    height: 6rem;
    line-height: 2rem;

.item:hover .card-description
  opacity: 1;
  transition: opacity .35s ease-out;

</style>



// WEBPACK FOOTER //
// src/templates/default/components/list-item.vue